// ABOUTME: The query params a shared calendar link is made of, named in one place
// ABOUTME: Each builder has to know the others' names to leave their params where they are

export const WORKOUT_URL_PARAM = "workoutID"
export const NUTRITION_URL_PARAM = "nutrition"
export const PLAN_URL_PARAM = "plan"
/** Whose calendar the link points into — the workout link and the meal-plan link share it. */
export const ATHLETE_URL_PARAM = "athlete"
